import {CustomerNotes} from 'app/features/orders/componentsv1'
import {FC, useState} from 'react'
import CustomerNoteDialog from './CustomerNoteDialog'

type Props = {
  note: any
  notes: any[]
  isEditable?: boolean
}

export const CustomerNoteWrapper: FC<Props> = ({notes, note, isEditable}) => {
  const [showDialog, setShowDialog] = useState(false)

  const handleOpen = () => {
    setShowDialog(true)
  }

  const handleClose = () => {
    setShowDialog(false)
  }

  return (
    <>
      <div className='pt-5'>
        <CustomerNotes
          note={note}
          onValueChange={() => null}
          showToolbar={true}
          notes={notes}
          toolbarTitle={isEditable ? 'View/Edit' : 'View'}
          onClick={handleOpen}
        />
      </div>
      {showDialog && (
        <CustomerNoteDialog onClose={handleClose} notes={notes} isEditable={isEditable} />
      )}
    </>
  )
}

export default CustomerNoteWrapper
